export enum FileActions {
  RENAME = 'RENAME',
  DELETE = 'DELETE',
  DELETE_OR_PURGE = 'DELETE_OR_PURGE',
  DISPATCH_DELETE = 'DISPATCH_DELETE',
  DISPAtCH_RENAME = 'DISPAtCH_RENAME',
  DISPATCH_DELETE_OR_PURGE = 'DISPATCH_DELETE_OR_PURGE',
  MOVE = 'MOVE',
  COPY = 'COPY',
  DOWNLOAD = 'DOWNLOAD',
  CREATE = 'CREATE',
  CREATE_PROJECT = 'CREATE_PROJECT',
  DELETE_PROJECT = 'DELETE_PROJECT',
  EXIT_PROJECT = 'EXIT_PROJECT',
  UPLOAD_FILE = 'UPLOAD_FILE',
  UPLOAD_FOLDER = 'UPLOAD_FOLDER',
  PREVIEW = 'PREVIEW',
  PLAY_OR_PAUSE = 'PLAY_OR_PAUSE',
  SELECT_PREV = 'SELECT_PREV',
  SELECT_NEXT = 'SELECT_NEXT',
  SELECT_ALL = 'SELECT_ALL',
  SHARE = 'SHARE',
  COLLECTION = 'COLLECTION',
  INVITE_MEMBER = 'INVITE_MEMBER',
  PROJECT_SETTING = 'PROJECT_SETTING',
  RESTORE = 'RESTORE',
  PURGE = 'PURGE',
  PURGE_ALL = 'PURGE_ALL',
  REVIEW_STATUS = 'REVIEW_STATUS',
  PAUSE_UPLOAD = 'PAUSE_UPLOAD',
  RESUME_UPLOAD = 'RESUME_UPLOAD',
  CANCEL_UPLOAD = 'CANCEL_UPLOAD',
  LOCATE_FILE = 'LOCATE_FILE',
  PUBLISH = 'PUBLISH',
  CREATE_NOTE = 'CREATE_NOTE',
  PICTURE_IMAGINE = 'PICTURE_IMAGINE',
  SPEECH_TO_TEXT = 'SPEECH_TO_TEXT',
  CREATE_FTP = 'CREATE_FTP',
  MODIFY_PASSWORD = 'MODIFY_PASSWORD'
}
